import * as TypeStyle from 'typestyle';
import { InvertTextColors, TextColors } from '../../styles/Colors';
import { AlignItemsCenter } from '../../styles/Flexbox';
import { ListAndMenuItemHeight } from '../List/ListStyles';

export const BreadcrumbDividerWidth = 9;
export const BreadcrumbSpacing = 8;
export const BreadcrumbsMenuButtonMinWidth = 30;

export const BreadcrumbsDivStyleName = TypeStyle.style({
  alignItems: 'center',
  display: 'inline-flex',
  margin: '9px 0',
  minWidth: BreadcrumbsMenuButtonMinWidth,
  whiteSpace: 'nowrap',
  width: 'inherit',
});

export const BreadcrumbsNavStyleName = TypeStyle.style({
  display: 'inline-block',
  whiteSpace: 'nowrap',
});

export const BreadcrumbsListStyleName = TypeStyle.style({
  alignItems: 'center',
  display: 'flex',
  listStyle: 'none',
  margin: 0,
  paddingLeft: 0,
});

export const BreadcrumbStyleName = TypeStyle.style({
  color: TextColors.Primary,
  $nest: {
    '&.darkBackground': {
      color: InvertTextColors.Primary,
    },
  },
});

export const BreadcrumbDividerStyleName = TypeStyle.style({
  color: '#333',
  display: 'inline-flex',
  margin: `0px ${BreadcrumbSpacing}px`,
  width: BreadcrumbDividerWidth,
  $nest: {
    '&.darkBackground': {
      color: '#bfbfbf',
    },
  },
});

export const BreadcrumbMenuButtonStyleName = TypeStyle.style({
  width: BreadcrumbsMenuButtonMinWidth,
  $nest: {
    '&&&&::after': { display: 'none' }, // no arrow icon
  },
});

export const BreadcrumbsOverflowListStyleName = TypeStyle.style({
  listStyle: 'none',
  margin: 8,
  paddingLeft: 0,
  $nest: {
    '& li': {
      ...AlignItemsCenter,
      display: 'flex',
      height: ListAndMenuItemHeight,
    },
  }
});

export const TrailingElementsContainerStyleName = TypeStyle.style({ flexShrink: 0 });
